"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisintegrateAbilityHandler = exports.DisintegrateActorAbilityFactory = exports.DisintegrateAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Unblockable_1 = require("../../core/effects/core/Unblockable");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
class DisintegrateAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Disintegrate;
        this.__typeName = "Disintegrate";
    }
}
exports.DisintegrateAbilityArgs = DisintegrateAbilityArgs;
let DisintegrateActorAbilityFactory = class DisintegrateActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Disintegrate", "OneEnemies", 4);
    }
};
DisintegrateActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Disintegrate")
], DisintegrateActorAbilityFactory);
exports.DisintegrateActorAbilityFactory = DisintegrateActorAbilityFactory;
let DisintegrateAbilityHandler = class DisintegrateAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            effect: new Unblockable_1.UnblockableEffectArgs(),
            duration: Duration_1.Duration.EndOfTurn,
            onApplied: sequence => {
                const percentHealth = container.getAttributeScore(ability.invokerId, AttributeType_1.AttributeType.Health)
                    / container.getMaxAttributeScore(ability.invokerId, AttributeType_1.AttributeType.Health);
                container.applyProjectileAttackWithDamage({
                    sequence,
                    abilityKey: ability.args.__typeName,
                    attackType: "magic",
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    projectileType: "PurpleComet",
                    projectilePath: "line",
                    toApply: [
                        AbilityDamage_1.AbilityDamage.Focus("Death", 220 - Math.round(170 * percentHealth))
                    ]
                });
            }
        });
    }
};
DisintegrateAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Disintegrate)
], DisintegrateAbilityHandler);
exports.DisintegrateAbilityHandler = DisintegrateAbilityHandler;
